//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/SIM.PostConfigurator.js";
import "../no/Builder.js";
let d=[[[0,"ControllerName",1,0],[0,"CreateDirectoryForPostprocessor",1,0],[0,"MachineName",1,0],[0,"ManufacturerName",1,0],[0,"PostprocessorName",1,0],[0,"PostprocessorOutputDirectory",1,0]],[[["count"],"GetControllerNames",{R_:{controllerNames:""}},0,0],[["count"],"GetManufacturerNames",{R_:{manufacturerNames:""}},0,0],[["count"],"GetMachineNames",{R_:{machineNames:""}},0,0],[["layerName"],"GetLayerNameValue",{R_:{value:''}},1,0],[["layerName","value"],"SetLayerNameValue",{},2,0],[["layerName","count"],"GetLayerNames",{R_:{layerValues:""}},1,0],[["toggle"],"ToggleNcOptimizer",{},1,0]],[]];
SPLM.SIM.PostConfigurator.CreationPostBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SIM.PostConfigurator.CreationPostBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;